<ion-content class="login-bg">
  <div class="login-wrap">
    <ion-card class="login-card">
      <ion-card-header>
        <ion-card-title>Bejelentkezés</ion-card-title>
        <ion-card-subtitle>Helyi hozzáférés</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <form (ngSubmit)="belepes()">
          <ion-item>
            <ion-label position="stacked">Felhasználónév</ion-label>
            <ion-input [(ngModel)]="username" name="username" autocomplete="username"
                       autocapitalize="off" [disabled]="folyamatban" required></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Jelszó</ion-label>
            <ion-input [(ngModel)]="password" name="password" type="password"
                       autocomplete="current-password" [disabled]="folyamatban" required></ion-input>
          </ion-item>

          <ion-text color="danger" *ngIf="hiba">
            <p class="hiba">{{ hiba }}</p>
          </ion-text>

          <ion-button expand="block" type="submit" [disabled]="folyamatban" class="belep-gomb">
            <ion-spinner *ngIf="folyamatban" name="dots"></ion-spinner>
            <span *ngIf="!folyamatban">Belépés</span>
          </ion-button>
        </form>
      </ion-card-content>
    </ion-card>
    <!-- Lábléc: az akadálymentesítési nyilatkozat (2018. évi LXXV. tv.) és az adatkezelési szabályzat
         (Nkt. 43. § (1)) belépés nélkül is elérhető. -->
    <footer class="login-lablec">
      <a routerLink="/akadalymentesseg">Akadálymentesítési nyilatkozat</a>
      <span aria-hidden="true"> · </span>
      <a routerLink="/adatkezeles">Adatkezelési szabályzat</a>
    </footer>
  </div>
</ion-content>
